import React from 'react';
import PropTypes from 'prop-types';

import { assignmentGradesType } from '../../types';
import { Container, GradeLabel } from './GradeCell.styled';
import InfoTags from '../InfoTags';

import { Assignment as AssignmentType } from '$variables/types';

import GradeNow from '../GradeNow';

const GradeCell = ({
  assignment,
  assignmentGrades,
  launchTurnitinAssignment,
}) => {
  if (!assignmentGrades[assignment.id]) {
    return null;
  }

  const {
    displayGrade: grade,
    hasSubmission,
    lateSubmission,
    isAwaitingDecision,
  } = assignmentGrades[assignment.id];

  const notGraded = hasSubmission && !lateSubmission && !grade;
  const shouldShowGrade = grade && !isAwaitingDecision;

  return (
    <Container>
      {shouldShowGrade && <GradeLabel>{grade}</GradeLabel>}
      <InfoTags
        hasSubmission={hasSubmission}
        isAwaitingDecision={isAwaitingDecision}
        lateSubmission={lateSubmission}
        grade={grade}
        provider={assignment.provider}
      />
      {notGraded && (
        <GradeNow
          launchTurnitinAssignment={launchTurnitinAssignment}
          assignment={assignment}
        />
      )}
    </Container>
  );
};

GradeCell.propTypes = {
  assignmentGrades: assignmentGradesType,
  assignment: AssignmentType.isRequired,
  launchTurnitinAssignment: PropTypes.func.isRequired,
};

GradeCell.defaultProps = {
  assignmentGrades: {},
};

export default GradeCell;
